import { render, staticRenderFns } from "./anonymousLogin.vue?vue&type=template&id=08c41df6&scoped=true&"
import script from "./anonymousLogin.vue?vue&type=script&lang=js&"
export * from "./anonymousLogin.vue?vue&type=script&lang=js&"
import style0 from "./anonymousLogin.vue?vue&type=style&index=0&id=08c41df6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c41df6",
  null
  
)

export default component.exports